import { Padding } from "@mui/icons-material";

export const topmenuStyles = {
    top_menu: {
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: '#432F60',
        background: `linear-gradient(to right, #9E3C5D, #432F60)`,
        // background: 'linear-gradient(to right, #432F60, #9E3C5D )'
    }
};